import React, { Component } from 'react';
import { REACT_APP_API_BASE } from '../../config';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import ReportHeader from '../../components/statistics/report-header';
import ReportRenderer from '../../components/statistics/report-renderer';
import ExportFooter from '../../components/export-footer/footer';
import { ButtonComponent } from '../../components/export-btn';
import Disclaimer from './disclaimer';
import './report.scss';
class Report extends Component {
    
    state = {
        report: null,
        isLoading: true,
        isLoadingReport: false,
        isLoadingPeriods: false,
        isPaginating: false,
        isExporting: false,
        isExportingFinished: false,
        exportFormat: 'EXCEL',
    };

    getMimeType(format) {
        switch (format) {
            case 'EXCEL':
                return 'application/vnd.ms-excel';
            case 'WORDOPENXML':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'PDF':
                return 'application/pdf';
            default:
                return '';
        }
    }

    async exportReport(format) {

        this.setState({
            isExporting: true
        });

        const body = { 
            ...this.state.report, 
            reportPath: this.getReportPath(),
            selectedFormat: format };

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');


        const rawResponse = await fetch(`${REACT_APP_API_BASE}/rsreport/render`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });

        if (rawResponse.ok) {
            const exportReport = await rawResponse.json();
            var binaryString = window.atob(exportReport.result);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }

            var blob = new Blob([bytes], { type: this.getMimeType(format) });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.state.report.branchName}.xls`;
            link.click();

            this.setState({
                isExporting: false,
                isExportingFinished: true
            });

            setTimeout(() => {
                this.setState({
                    isExportingFinished: false,
                    exportFormat:'EXCEL'
                });
            }, 4000);
        }
    }

    getReportPath() {
        const { match } = this.props;
        return `/${match.params.env}/${match.params.report}`;
    }

    async loadReportHeader() {
        
        const { match } = this.props;
        
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/rsreport/load/company/${match.params.companyId}/year/0/report${this.getReportPath()}`);
        if (!res.ok) {
            //handle 404
        }

        const report = await res.json();

        this.setState({
            report,
            isLoading: false
        });

        await this.loadReport();
    }

    async loadReport(currentPage = 1, isPaginating = false) {
        this.setState({
            isLoadingReport: true,
            isPaginating
        });

        const { branchName, ...rest } = this.state.report;
        const body = { 
                        ...rest, 
                        reportPath: this.getReportPath(),
                        currentPage: currentPage,
                        selectedFormat: 'HTML5' };
        
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
      
        const rawResponse = await fetch(`${REACT_APP_API_BASE}/rsreport/render`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });
        
        if (rawResponse.ok) {
            const report = await rawResponse.json();

            this.setState({
                report: 
                {
                    ...report, 
                    parameters: this.state.report.parameters, 
                    reportType: this.state.report.reportType, 
                    branchName: this.state.report.branchName,
                    additionalInfo:  this.state.report.additionalInfo,
                    selectedCompany: this.state.report.selectedCompany
                },
                isLoadingReport: false,
                isPaginating: false
            });

            if (isPaginating && window) {
                window.scrollTo(0, 0);
            }
        }
    }

    async handleParameterChange(param) {    
        
        let index = this.state.report.parameters.findIndex(x => x.name === param.name);

        if (index > -1) {
            if (param.name === 'Year' && this.state.report.parameters.length > 1 && param.selectedValues[0] !== '') {
                this.setState({
                    isLoadingPeriods: true
                });
                
                const { match } = this.props;
                const res = await this.props.fetch(`${REACT_APP_API_BASE}/rsreport/load/company/${match.params.companyId}/year/${param.selectedValues[0]}/report${this.getReportPath()}`);
                if (!res.ok) {
                    //handle 404
                }
        
                const reportRes = await res.json();
                const parameters = [...reportRes.parameters];
                parameters[index] = param;
    
                const report = {...reportRes, parameters };

                this.setState({
                    report,
                    isLoadingPeriods: false
                });
            } else {
                const parameters = [...this.state.report.parameters];
                parameters[index] = param;
    
                const report = {...this.state.report, parameters };
                this.setState({
                    report
                });
            }
        }
    }

    handleExportFormatChange(e) {
        const exportFormat = e.currentTarget.value;
        this.setState({
            exportFormat
        });
    }

    async handleExport(e) {
        e.preventDefault();
        if (this.state.exportFormat !== '') {
            await this.exportReport(this.state.exportFormat);
        }
    }
    
    componentDidMount() {
        this.loadReportHeader();
    }

    getExportStateText() {
        if (this.state.isExporting) {
            return 'Exporterar';
        }

        if (this.state.isExportingFinished) {
            return 'Klar!';
        }

        return 'Exportera';
    }
    
    render() {
        return (
            <div className="report">
                <ReportHeader 
                    {...this.state} 
                    handleParameterChange={(obj) => this.handleParameterChange(obj)} 
                    loadReport={(page) => this.loadReport(page)} 
                    exportReport={(format) => this.exportReport(format)} 
                    isLoading={this.state.isLoading}
                    isLoadingReport={this.state.isLoadingReport} 
                    isLoadingPeriods={this.state.isLoadingPeriods} />

                <ReportRenderer 
                    {...this.state} 
                    isLoading={this.state.isLoadingReport} 
                    isPaginating={this.state.isPaginating}
                    loadReport={(page, isPaginating) => this.loadReport(page, isPaginating)} />

                {this.state.report && this.state.report.formats &&
                    <>  
                        <Disclaimer />
                        
                        <form method="post" onSubmit={(e) => this.handleExport(e)}>
                            <ExportFooter 
                                modifiers={{
                                    'report__footer': true,
                                    'report__footer--is-exporting': this.state.isExporting,
                                    'report__footer--is-loading-report': this.state.isLoadingReport
                                }} 
                                isExporting={this.state.isExporting}
                                isExportingFinished={this.state.isExportingFinished}
                                value={this.state.exportFormat}
                                onChange={(e) => this.handleExportFormatChange(e)}
                                name="export" 
                                btnComponent={<ButtonComponent disabled={this.state.exportFormat === ''} text={this.getExportStateText()} />} />
                                {/*<option value="">Välj filformat</option>
                                {this.state.report.formats.map((format, i) => {
                                    if (!format.visible) return null;

                                    return (
                                        <option key={`export-${i}`} value={format.name}>{format.description}</option>
                                    );
                                })}
                            </ExportFooter>*/}
                        </form>
                    </>
                }
            </div>
        );
    }
};

export default withAuthProvider(withFetch(Report));